import Navigation from '@/components/Navigation';
import HeroSection from '@/components/HeroSection';
import ServicesSection from '@/components/ServicesSection';
import AboutSection from '@/components/AboutSection';
import ReferencesSection from '@/components/ReferencesSection';
import JoinUsSection from '@/components/JoinUsSection';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <HeroSection />
      <ServicesSection />
      <AboutSection />
      <ReferencesSection />
      <JoinUsSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default Index;
